function initHome() {
	$(".group-select__item").mouseenter(function() {
		$(this).addClass("group-select__item--active");
	}).mouseleave(function() {
		$(this).removeClass("group-select__item--active");
	});
}